<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Talimatı Veren Kişi</label>
            <v-select-list
                v-model="form.selectedOrderedBy"
                :options="personnel"
                label="FullName"
                placeholder="Aramak için personel adı giriniz..."
                v-on:search="onPersonnelSearch"
                :filterable="false"
            ></v-select-list>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Onay Verecek Kişi</label>
            <v-select-list v-model="form.selectedApprover" :options="approvers" label="FullName" placeholder="Onaycı seçiniz..."></v-select-list>
        </div>

        <div class="col-12">
            <label class="form-label">Açıklama</label> <textarea class="form-control" rows="4" v-model="form.description" placeholder="İşlemle ilgili bir açıklama giriniz..."></textarea>  
        </div>
    </div>
</template>

<script>
export default {
    name: "ApprovalRequestModalContent",
    props: {
        personnel: {
            type: Array,
            default: () => [],
        },
        approvers: {
            type: Array,
            default: () => [],
        },
        value: {
            type: Object,
            required: true,
        },
    },
    computed: {
        form: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            },
        },
    },
    methods: {
        onPersonnelSearch(searchKey) {
            this.$emit("search-personnel", searchKey);
        },
    },
};
</script>
